import React, { useEffect } from "react";
import OrganizedTourProfileHero from "./OrganizedTourProfileHero";
import OrganizedTourProfileStickyBooking from "./OrganizedTourProfileStickyBooking";
import "../OrganizedTourProfilePage.scss";

export default function OrganizedTourProfileLayout({
  viewModel,
  heroCtaLabel,
  onHeroCta,
  onStickyContinue,
  stickyContinueLabel,
  roomsAndPaxInfo,
  leftToPay,
  agentPanel,
  children,
}) {
  useEffect(() => {
    if (!import.meta.env?.DEV) return;
    console.log("[ORG_TOUR_PROFILE_RENDER]", {
      tourName: viewModel?.tourName,
      dealId: viewModel?.dealId,
    });
  }, [viewModel?.tourName, viewModel?.dealId]);

  const scrollToTravelers = () => {
    const el = document.getElementById("otp-section-travelers");
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollToFooter = () => {
    const el = document.getElementById("org-tour-summary-footer");
    el?.scrollIntoView({ behavior: "smooth", block: "end" });
  };

  const handleCta = onStickyContinue || onHeroCta || scrollToFooter;

  return (
    <div className="otp-page">
      <OrganizedTourProfileHero
        viewModel={viewModel}
        onPrimaryCta={onHeroCta || scrollToTravelers}
        primaryCtaLabel={heroCtaLabel || "מילוי פרטי נוסעים"}
      />

      <div className="otp-page__grid">
        <main className="otp-page__main">{children}</main>

        <div className="otp-page__rail" role="complementary" aria-label="ניהול הצעה ותשלום">
          {agentPanel ? <div className="otp-page__agent otp-page__agent--rail">{agentPanel}</div> : null}
          <OrganizedTourProfileStickyBooking
            viewModel={viewModel}
            roomsAndPaxInfo={roomsAndPaxInfo}
            leftToPay={leftToPay}
            onContinue={handleCta}
            continueLabel={stickyContinueLabel || "המשך בהזמנה"}
          />
        </div>
      </div>
    </div>
  );
}
